import { TPromotion } from '../../types/config';

export const bgCss = (promo: TPromotion) => {
  const style: React.CSSProperties = {};
  if (promo.bgColor) {
    style.backgroundColor = promo.bgColor;
  }
  if (promo.bgImage) {
    style.backgroundImage = `url("${promo.bgImage}")`;
    style.backgroundSize = 'contain';
    style.backgroundPosition = 'center';
    style.backgroundRepeat = 'no-repeat';
  }
  return style;
};

export const overlayCss = (promo: TPromotion) => {
  const style: React.CSSProperties = {};
  if (promo.overlayColor && promo.overlaySecondColor) {
    style.background = `linear-gradient(
      ${promo.overlayAngle || '0'}deg,
      ${promo.overlayColor} 0%,
      ${promo.overlaySecondColor} 100%
    )`;
  } else {
    style.backgroundColor = promo.overlayColor;
  }
  return style;
};
